import { styled } from "styled-components";
import LogoImg from "../../../../../image/logo.png";

export const SignUpPageTitle = styled.div`
  font-size: 32px;
  line-height: 150px;

  background-image: url(${LogoImg});
  background-repeat: no-repeat;
  background-size: 350px;
  background-position-x: 200px;
  background-position-y: -105px;

  width: 450px;
`;
